function IndivisualExcelData({ row }) {
  return (
    <>
      <td>{row["Project Name"]}</td>
      <td>{row["RERA Registration No"]}</td>
      <td>{row["Locality Name"]}</td>
      <td>{row["City"]}</td>
      <td >
        <span
          className={`badge rounded-pill ${row["Status"] === "New Project" ? "bg-danger" : "bg-warning"
            }`}
        >
          {row["Status"]}
        </span>

      </td>
    </>
  );
}

export default IndivisualExcelData;
